import { TPAComponentProps } from '../../types';

export enum ToastSkin {
  status = 'status',
  success = 'success',
  error = 'error',
  preview = 'preview',
}

export enum ToastPlacement {
  inline = 'inline',
  bottomFullWidth = 'bottomFullWidth',
}

export interface ToastProps extends TPAComponentProps {
  /** Define the styles for toast */
  skin: ToastSkin;
  /** Is toast visible or not. For correct animation we should keep element in the DOM all time*/
  isShown?: boolean;
  /** Define appearing and disappearing toast. Should it be animated or not */
  shouldAnimate?: boolean;
  shouldShowCloseButton?: boolean;
  /** Callback function, will be called when click on close button */
  onClose?(event: MouseEvent): void;
  placement?: ToastPlacement;
  children?: React.ReactNode;
}

export interface ToastDefaultProps {
  shouldShowCloseButton: boolean;
  isShown: boolean;
}
